import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allVirtualMachines: [],
  customersVirtualMachine: [],
  virtualMachine: null,
  virtualMachineMonitoringRecords: [],
  allVirtualNetworks: [],
  customersVirtualNetworks: [],
  virtualNetwork: null,
  isLoading: false,
  error: null,
};

const openNebulaSlice = createSlice({
  name: 'openNebula',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = null;
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    },
    setAllVirtualMachines: (state, action) => {
      state.allVirtualMachines = action.payload;
      state.isLoading = false;
    },
    setCustomersVirtualMachine: (state, action) => {
      state.customersVirtualMachine = action.payload;
      state.isLoading = false;
    },
    setVirtualMachine: (state, action) => {
      state.virtualMachine = action.payload;
      state.isLoading = false;
    },
    setVirtualMachineMonitoringRecords: (state, action) => {
      state.virtualMachineMonitoringRecords = action.payload;
      state.isLoading = false;
    },
    setAllVirtualNetworks: (state, action) => {
      state.allVirtualNetworks = action.payload;
      state.isLoading = false;
    },
    setCustomersVirtualNetworks: (state, action) => {
      state.customersVirtualNetworks = action.payload;
      state.isLoading = false;
    },
    setVirtualNetwork: (state, action) => {
      state.virtualNetwork = action.payload;
      state.isLoading = false;
    },
    setResetOpenNebula: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllVirtualMachines,
  setCustomersVirtualMachine,
  setVirtualMachine,
  setVirtualMachineMonitoringRecords,
  setAllVirtualNetworks,
  setCustomersVirtualNetworks,
  setVirtualNetwork,
  setResetOpenNebula,
} = openNebulaSlice.actions;

export default openNebulaSlice.reducer;
